export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export interface HttpClientOptions {
  csrfToken?: string;
  staticGetResolver?: StaticGetResolver;
}

export const STATIC_GET_HANDLED_NOT_FOUND = Symbol('STATIC_GET_HANDLED_NOT_FOUND');

export type StaticGetResolver = (url: string) => unknown | undefined;

export type InterceptorFunction = (response: Response) => void;
export type Interceptor = {
  path: string | RegExp;
  function: InterceptorFunction;
};

export interface IAstratoHttpClient<S = never> {
  addResponseErrorInterceptor(interceptor: Interceptor): void;
  removeResponseErrorInterceptor(interceptor: InterceptorFunction): void;
  get<T>(url: string, token?: string, headersExtension?: HeadersInit, context?: S): Promise<T>;
  patch<T, R>(url: string, data?: Partial<T>, token?: string, headersExtension?: HeadersInit, context?: S): Promise<R>;
  delete<R>(url: string, token?: string, headersExtension?: HeadersInit, context?: S): Promise<R>;
  post<T, R>(url: string, data?: Partial<T>, token?: string, headersExtension?: HeadersInit, context?: S): Promise<R>;
  put<T, R>(url: string, data?: Partial<T>, token?: string, headersExtension?: HeadersInit, context?: S): Promise<R>;
}
